module.exports = __webpack_public_path__ + "static/img/network_card.4313e0e.png";